import Alert from "shared/UI/Alerts/Alert";
import Button from "shared/UI/Buttons/Button";
import { appInsights } from "core/monitoring/AppInsights";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

const devMode = !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export interface Error404Props {
  fullscreen?: boolean;
  message?: string;
  resetErrorBoundary?: () => void;
};

export function Error404({ message, resetErrorBoundary = () => { }, fullscreen = true }: Error404Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div data-testid="error-404-container" className={classNames({ "h-screen w-screen": fullscreen }, `flex flex-col items-center justify-center`)}>
      <div className="w-full max-w-[350px] px-4">
        <Alert icon="error" size="base" title={t("generalErrors.title")} type="error">
          <p className="message">{message}</p>
        </Alert>
        <Button
          onClick={() => {
            resetErrorBoundary();
            navigate("/");
          }}
          text={"Go to Home"}
        /></div>
    </div>
  );
}

export function handleError(error: Error) {
  if (!devMode) {
    const exception = { exception: error, severityLevel: 3 };
    appInsights.trackException(exception);
  }
}
